import store from '..'
import axios from 'axios'
import API from '@/common/api'

export default {
  namespaced: true,
  state: {
  },
  mutations: {
  },
  actions: {
    async getLayerpopup () {
      try {
        const res = await axios.post(`${API.BASE_URL}/castit/file`, {
          ...API.GET_GVF_PARAMS,
          id: store.state.authentication.requestId,
          file: 'layerpopup/layerpopup.json'
        })
        return res.data.message
      } catch (ex) {
        // alert(ex)
        console.log(ex)
        return false
      }
    },
    async setLayerpopup ({ state }, data) {
      try {
        return await axios.post(`${API.BASE_URL}/castit/file`, {
          ...API.SET_GVF_PARAMS,
          id: store.state.authentication.requestId,
          file: 'layerpopup/layerpopup.json',
          data: JSON.stringify(data)
        })
      } catch (ex) {
        alert(ex)
        console.log(ex)
        return false
      }
    }
  },
  getters: {
  }
}
